export default "__VITE_ASSET__6qqYBDKb__"